import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'superflex-guardar-btn',
    template: `
    <p-button
        label="{{ 'BOTONES.btnGuardar' | translate }}"
        [styleClass]="styleClass"
        [class]="class"
        [icon]="icon"
        (onClick)="onClick.emit()"
        [disabled]="isDisabled">
    </p-button>`,
})
export class GuardarBtnComponent {
    @Input() isDisabled: boolean;
    @Input() icon = '';
    @Output() onClick = new EventEmitter<any>();
    @Input() styleClass = 'p-mr-2';
    @Input() class = '';
}
